import React from "react";
import {DateRangePicker} from "react-date-range";
import de from "date-fns/locale/de";
import "react-date-range/dist/styles.css"; // main style file
import "./DatePickerTheme.css"; // theme css file

interface DatePickerCardProps {
    startDate: Date;
    setStartDate: (start: Date) => void;
    endDate: Date;
    setEndDate: (stop: Date) => void;
    period: number;
    setPeriod: (newPeriod: number) => void;
    start?: string;
    stop?: string;
}
const DatePickerCard = (props: DatePickerCardProps) => {
    const {startDate, setStartDate, endDate, setEndDate, period, setPeriod} = props;

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: "selection",
    };

    const validPeriods = ["week", "two weeks", "month", "quarter", "year"];

    const handleChanges = w => {
        const [start, stop] = [w.selection.startDate, w.selection.endDate];
        setStartDate(start);
        setEndDate(stop);
    };
    const handlePeriod = way => {
        const newPeriod = period + way;
        setPeriod(newPeriod);

        if (newPeriod >= validPeriods.length) {
            setPeriod(0);
        }
        if (newPeriod < 0) {
            setPeriod(validPeriods.length - 1);
        }
        let newStart: Date;
        const end = endDate;

        switch (validPeriods[newPeriod]) {
            case "year":
                newStart = new Date(end);
                newStart = new Date(newStart.setDate(end.getDate() - 365));
                break;
            case "quarter":
                newStart = new Date(end);
                newStart = new Date(newStart.setMonth(end.getMonth() - 3));
                break;
            case "month":
                newStart = new Date(end);
                newStart = new Date(newStart.setMonth(end.getMonth() - 1));
                break;
            case "two weeks":
                newStart = new Date(end);
                newStart = new Date(newStart.setDate(end.getDate() - 13));
                break;
            case "week":
                newStart = new Date(end);
                newStart = new Date(newStart.setDate(end.getDate() - 6));
                break;
            default:
                newStart = new Date(end);
                newStart = new Date(newStart.setDate(end.getDate() - 6));
        }
        setStartDate(newStart);
        setEndDate(end);
    };
    return (
        <div className={"DatePickerCard flex flex-col justify-between items-stretch space-y-4"}>
            <div className={"DatePickerCardHeader flex-shrink-0 text-sm w-full flex flex-row justify-between items-center"}>
                <span className={"p-1 flex-grow text-center rounded-full border border-gray-800 bg-white"}>{startDate?.toLocaleDateString("de")}</span>
                <span className={"w-8 flex-shrink-0 text-center"}>-</span>
                <span className={"p-1 flex-grow text-center rounded-full border border-gray-800  bg-white"}>{endDate?.toLocaleDateString("de")}</span>
            </div>
            <div className={"PeriodPicker h-10"}>
                <div className={"flex flex-row justify-between items-center bg-red-500 rounded-full px-2 py-1 text-lg text-white leading-3"}>
                    <button className={"text-left text-xl leading-4 p-2"} type={"button"} onClick={() => handlePeriod(-1)}>
                        &lt;
                    </button>
                    <div className={"text-center py-1"}>{validPeriods[period]}</div>
                    <button className={"text-right p-2"} type={"button"} onClick={() => handlePeriod(1)}>
                        &gt;
                    </button>
                </div>
            </div>

            <DateRangePicker
                color="#ff0f0f"
                inputRanges={[]}
                // staticRanges={defaultStaticRanges}
                locale={de}
                maxDate={new Date()}
                months={2}
                ranges={[selectionRange]}
                showDateDisplay={false}
                showPreview={false}
                staticRanges={[]}
                onChange={handleChanges}
            />
        </div>
    );
};

export default DatePickerCard;
